import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useTimeout } from 'react-nb-hooks'

import { translateLKM } from './helpers'
import LKModal, { LKModalContainer } from '../shared/LKModal'
import { lock } from '../../store/auth'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .timeout-logo {
    margin: 0 20px;
    width: 150px;
  }
`

const ActivityTimeout = ({ modalInstanceName }) => {
  const dispatch = useDispatch()

  const handleLock = React.useCallback(() => {
    dispatch(lock('უმოქმედობის გამო სესიის დრო ამოიწურა'))
  }, [dispatch])

  useTimeout(handleLock, 1000 * 60)

  return (
    <LKModal icon="alert" name={modalInstanceName} heading={translateLKM('MSG_WARNING')} onClose={handleLock} size="xs">
      <Wrapper>
        <img className="timeout-logo" src="/static/img/test_logo.png" alt="logo" />
        <span>სესიას ვადა გაუვიდა (უმოქმედობის გამო)</span>
      </Wrapper>
    </LKModal>
  )
}

export default LKModalContainer('ActivityTimeout')(ActivityTimeout)
